// libs
import { styled } from '@nykaa/ui-components';

// global components
import Image from 'shared/components/Image';
import Wishlist from 'shared/components/Wishlist/index';

//  mixins
import { truncate } from 'shared/styles/mixin/core';

// constants
import { FONTS, BREAKPOINTS, BASE_GUTTER_SPACE, COLORS } from 'shared/styles/base';

export const ProductAnchor = styled.a`
  display: flex;
  position: relative;
  text-align: center;
  padding: 0;
  font-family: ${FONTS.BASE_FAMILY};
  text-decoration: none;
  cursor: pointer;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    &:hover {
      box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
      z-index: 1;
    }
  }

  .product__image {
    position: relative;
    overflow: hidden;
  }
`;

export const imgClassName = 'plp-mweb-img';

export const ProductImage = styled(Image)<{ imageContain: boolean }>`
  display: block;

  & .${imgClassName} {
    ${({ imageContain }) =>
      imageContain &&
      `
        background: #fff;
        object-fit: scale-down;
        `}
  }
`;

export const Placeholder = styled.div`
  width: 100%;
  padding-top: 133.335%;
  background: ${COLORS.PLACEHOLDER};
`;

export const Description = styled.div<{
  hasTags: boolean;
  isFloating: boolean;
  canShowSizes: boolean;
  containsDynamicText: boolean;
}>`
  padding: ${BASE_GUTTER_SPACE}px ${BASE_GUTTER_SPACE}px 10px;
  position: relative;
  text-align: left;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`;

export const Title = styled.div`
  ${truncate}

  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${COLORS.BLACK_92};
  margin-bottom: 3px;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export const SubTitle = styled.div`
  ${truncate}

  ${({ theme }) => theme.typography.bodySmall};
  margin-bottom: 5px;
  color: ${COLORS.BLACK_64};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
  }
`;

export const Sizes = styled.p`
  ${truncate}

  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${COLORS.BLACK_64};
  margin: 6px 0 0;
`;

const BaseSoldOut = styled.span`
  position: absolute;
  height: 26px;
  left: 50%;
  transform: translateX(-50%);
  top: -45px;
  color: #fff;
  ${({ theme }) => theme.typography.bodyLarge};
  background-color: #000;
  display: inline-block;
  text-align: center;
`;

export const SoldOut = styled(BaseSoldOut)`
  width: 90px;
`;

export const SizeSoldOut = styled(BaseSoldOut)`
  ${truncate}

  max-width: 90%;
  ${({ theme }) => theme.typography.bodySmall};
  padding: 0 ${BASE_GUTTER_SPACE}px;
  text-transform: capitalize;
`;

export const DyanamicText = styled.div<Listing.IDyanamicText>`
  margin-top: ${BASE_GUTTER_SPACE}px;
  ${({ theme }) => theme.typography.bodySmall}
  color: ${(props) => props.titleColor};
`;

export const CustomWislist = styled(Wishlist)`
  position: absolute;
  width: 32px;
  height: 32px;
  right: 4px;
  top: 4px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  & .circle {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }
`;
